export const ACCREDITATIONREVIEW = '/accreditationreview';

export const ACCREDITATIONS_APPLICATIONS = '/accreditationreview/accreditations';

export const ORGANIZATIONS = '/organizationsreview';

export const COMMON_POLITICAL_DIVISION = '/common/politicalDivisionreview';

export const DETAILS = '/detailsreview';

export const ANNEXES = '/annexesreview';

export const COMPLIANCE_COMMITMENT = '/complianceCommitmentreview';

export const SEND_REQUEST = '/sendRequestreview';

export const ACCREDITATION_REVIEW = '/accreditationReview';

export const REQUEST = '/request';

export const VIGILANCES = '/vigilancesreview/vigilances';